// modules
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import styled from 'styled-components';

// components
import ArticleList from 'components/ArticleList/ArticleList';
import FactCheck from 'components/FactCheck/FactCheck';
import Headline from 'components/Headline/Headline';
import ItemLoader from 'components/ItemLoader/ItemLoader';
import OnThisDay from 'components/OnThisDay/OnThisDay';
import Quote from 'components/Quote/Quote';
import TweetList from 'components/TweetList/TweetList';
import VideoPlayer from 'components/VideoPlayer/VideoPlayer';

// data
import { requestTrumpism } from 'actions/trumpisms';

// services
import { track } from 'services/analytics';
import { EVENTS, SOURCES } from 'services/analytics-constants';
import { TrumpismPropTypes } from 'services/dto/trumpism';

const Container = styled.div`
  padding: 20px;
`;

class Trumpism extends Component {
  static propTypes = {
    fetched: PropTypes.bool.isRequired,
    id: PropTypes.string.isRequired,
    requestTrumpism: PropTypes.func.isRequired,
    trumpism: TrumpismPropTypes
  };

  static defaultProps = {
    trumpism: null
  };

  componentWillMount() {
    const {
      match: {
        params: { id }
      },
      requestTrumpism,
      trumpism
    } = this.props;
    if (!trumpism) {
      requestTrumpism(id);
    }
  }

  trackSourceClicked = articleData => {
    const { trumpism } = this.props;

    track(EVENTS.CLICK_SOURCE_ARTICLE, {
      article: {
        ...articleData
      },
      trumpism: {
        trumpismDate: trumpism.get('date'),
        trumpismHeadline: trumpism.get('headline'),
        trumpismId: trumpism.get('id')
      },
      source: SOURCES.TRUMPISM
    });
  };

  render() {
    const { fetched, trumpism } = this.props;

    if (fetched && !trumpism) return <Redirect to="/not-found" />;
    if (!fetched && !trumpism) return <ItemLoader />;

    return (
      <Container>
        <Helmet>
          <meta name="og:type" content="website" />
          <meta name="og:description" content={trumpism.get('headline')} />
        </Helmet>
        <Headline text={trumpism.get('headline')} />
        <OnThisDay date={trumpism.get('date')} />
        <Quote text={trumpism.get('quote')} />
        <TweetList tweets={trumpism.get('tweets')} />
        <VideoPlayer url={trumpism.get('youTubeUrl')} />
        <FactCheck text={trumpism.get('factCheck')} />
        <ArticleList
          onClick={this.trackSourceClicked}
          sources={trumpism.get('sources')}
        />
      </Container>
    );
  }
}

export default connect(
  (
    state,
    {
      match: {
        params: { id }
      }
    }
  ) => {
    return {
      fetched: state.getIn(['trumpisms', 'fetched']),
      trumpism: state
        .getIn(['trumpisms', 'all'])
        .find(val => val.get('id') === id)
    };
  },
  { requestTrumpism }
)(Trumpism);



// WEBPACK FOOTER //
// ./src/views/Trumpism.js